<template>
  <div id="orderlist">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top:24px">
        <el-breadcrumb-item :to="{ path: '/formalProjectSitesManage' }" style="font-size:24px">项目点管理列表
        </el-breadcrumb-item>
        <el-breadcrumb-item style="font-size:24px">档口管理列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>

    <el-form :model="筛选表单" style="margin-top: 5px" :inline="true">
      <el-form-item label="档口状态：">
        <el-select  filterable v-model="筛选表单.档口状态" style="width: 200px;" >
          <el-option v-for="item in 档口状态列表" :key="item.id" :label="item.label" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button  @click="queryFormalSupplierListData()">筛选</el-button>
      </el-form-item>
    </el-form>


    <el-row>
      <el-col>
        <el-button size="small" @click="addUser()" style="margin-top:5px;margin-bottom:20px;">新增</el-button>
        <el-button size="small" @click="importDkDialog = true" style="margin-top:5px;margin-bottom:20px;">导入档口
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="formalSupplierListData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="NAME" label="名称" min-width="100"></el-table-column>
          <el-table-column prop="DK_TYPE" label="档口类型" min-width="100">
            <!-- <template slot-scope="scope">
              <span v-text="setStatus(scope.row)"></span>
            </template> -->
          </el-table-column>
          <el-table-column prop="MAX_PURCHASE" label="采购限额" min-width="150"></el-table-column>
          <el-table-column prop="INCOME_ADD_POINT" label="收入提点" min-width="150"></el-table-column>
          <el-table-column prop="DK_RATE" label="甲方扣点" min-width="150"></el-table-column>
          <el-table-column prop="LEADER_NAME" label="档口负责人" min-width="60"></el-table-column>
          <el-table-column prop="LEADER_CELLPHONE" label="联系电话" min-width="100"></el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-edit-outline" @click="edit(scope.row)">修改</el-button>
              <el-button type="text" size="small" icon="el-icon-close" style="color: #F56C6C" v-show="scope.row.STATUS === 1"
                         @click="stopUser(scope.row)">禁用
              </el-button>

              <el-button type="text" size="small" icon="el-icon-check" style="color: #82f382" v-show="scope.row.STATUS === 0"
                         @click="启用(scope.row)">启用
              </el-button>


            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 新增档口模态框 -->
    <el-dialog title="新增档口" center :visible.sync="addFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="addForm" ref="addForm" :rules="rules" style="margin-top: 0">
        <el-form-item label="档口名称：" :label-width="formLabelWidth" prop="name">
          <el-input v-model="addForm.name" auto-complete="off" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="名称缩写：" :label-width="formLabelWidth" prop="code">
          <el-input v-model="addForm.code" auto-complete="off" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="采购限额：" :label-width="formLabelWidth" prop="max_purchase">
          <el-input v-model="addForm.max_purchase" auto-complete="off" clearable>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="收入提点：" :label-width="formLabelWidth" prop="INCOME_ADD_POINT">
          <el-input v-model="addForm.INCOME_ADD_POINT" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="负责人：" :label-width="formLabelWidth" prop="leader">
          <label slot="label">负&nbsp;&nbsp;责&nbsp;&nbsp;人：</label>
          <el-select v-model="addForm.leader" placeholder="请选择负责人" style="width:100%" filterable clearable>
            <el-option v-for="item in users" :key="item.value" :label="item.NAME" :value="item.ID">
              <span style="float: left;text-align: center">{{ item.NAME }}</span>-<span>{{ item.CELLPHONE }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" required>
          <label slot="label">成本比例：</label>
          <el-col :span="11">
            <el-form-item prop="min_cost">
              <el-input v-model="addForm.min_cost" auto-complete="off" placeholder="最低成本比例" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2" style="text-align:center">-</el-col>
          <el-col :span="11">
            <el-form-item prop="max_cost">
              <el-input v-model="addForm.max_cost" auto-complete="off" placeholder="最高成本比例" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="甲方扣点：" :label-width="formLabelWidth" prop="DK_RATE">
          <el-input v-model="addForm.DK_RATE" auto-complete="off" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('addForm')">取 消</el-button>
        <el-button @click="submitAdd('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改档口信息模态框 -->
    <el-dialog title="修改档口信息" center :visible.sync="editFormVisible" width="600px">
      <el-form :model="editForm" ref="editForm" :rules="rules" style="margin: 0;padding: 0">
        <el-form-item label="档口名称：" :label-width="formLabelWidth" prop="NAME">
          <el-input v-model="editForm.NAME" auto-complete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="名称缩写：" :label-width="formLabelWidth" prop="DK_CODE">
          <el-input v-model="editForm.DK_CODE" auto-complete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="采购限额：" :label-width="formLabelWidth" prop="MAX_PURCHASE">
          <el-input v-model="editForm.MAX_PURCHASE" auto-complete="off" clearable>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="收入提点：" :label-width="formLabelWidth" prop="INCOME_ADD_POINT">
          <el-input v-model="editForm.INCOME_ADD_POINT" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="负责人：" :label-width="formLabelWidth" prop="LEADER_NAME" style="width:100%">
          <label slot="label">负&nbsp;&nbsp;责&nbsp;&nbsp;人：</label>
          <!-- <el-select v-model="editForm.LEADER_NAME" placeholder="请选择负责人" style="width:100%" filterable @change="getPhone" clearable> -->
          <el-select v-model="editForm.LEADER_NAME" placeholder="请选择负责人" style="width:100%" filterable
                     @change="getPhone" @clear='clearVal()' clearable>
            <el-option v-for="item in users" :key="item.value" :label="item.NAME" :value="item.ID">
              <span style="float: left;width: 50px;text-align: center">{{ item.NAME }}</span><span
              style="float: right;">{{ item.CELLPHONE }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="成本比例：" :label-width="formLabelWidth" required>
          <el-col :span="11">
            <el-form-item prop="DK_MIN_COST">
              <el-input v-model="editForm.DK_MIN_COST" auto-complete="off" style="width:100%" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2" style="text-align:center">-</el-col>
          <el-col :span="11">
            <el-form-item prop="DK_MAX_COST">
              <el-input v-model="editForm.DK_MAX_COST" auto-complete="off" style="width:100%" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="档口类型：" :label-width="formLabelWidth" prop="LEADER_NAME" style="width:100%">
          <el-select v-model="editForm.DK_TYPE_ID" placeholder="请选择档口类型" style="width:100%" filterable clearable>
            <el-option v-for="item in dkTypes" :key="item.value" :label="item.TYPE" :value="item.STATUS">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收入上报设置：" :label-width="formLabelWidth" prop="INCOME_FEE_APPORTION_TYPE"
                      style="width:100%">
          <el-switch v-model="editForm.INCOME_FEE_APPORTION_TYPE" active-text="允许分摊"
                     inactive-text="不允许分摊"></el-switch>
        </el-form-item>
        <el-form-item label="甲方扣点：" :label-width="formLabelWidth" prop="DK_RATE">
          <el-input v-model="editForm.DK_RATE" auto-complete="off" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('editForm')">取 消</el-button>
        <el-button @click="submitEdit('editForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导入档口 -->
    <el-dialog :visible.sync="importDkDialog" title="导入项目点" width="400px" center :close-on-click-modal="false">
      <el-form ref="importDkForm" v-model="importDkForm">
        <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :name="this.importDkForm.excel"
                   :multiple="false" :limit="1" accept=".xls, .xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="importDkDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitExportDk" :loading="loading12">确认</el-button>
      </div>
    </el-dialog>
    <!-- 导入档口出错提示 -->
    <el-dialog :visible.sync="errorDialog" title="错误原因" width="550px" center :close-on-click-modal="false">
      <template style="max-height:100px;overflow:auto">
        <div v-for="(item,index) in errorForm" :key="index">{{ item }}</div>
      </template>
    </el-dialog>

  </div>
</template>
<script>
import http from '@/api/base/http';
// eslint-disable-next-line no-unused-vars
import util from '@/common/util';
import {
  archivesMouthList, addArchivesMouth, editArchivesMouth, stopArchivesMouth, getUser,
} from '@/api/archivesMouths';
// eslint-disable-next-line no-unused-vars
import LoginVue from './Login.vue';
import { enableArchivesMouth } from '../api/archivesMouths';

export default {
  data() {
    // 内容验证
    const tel = /^1[345678]\d{9}$/;
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback('请输入手机号');
      } else if (tel.test(value)) {
        callback();
      } else {
        callback(new Error('请输入正确的手机号'));
      }
    };
    // var name = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,100}$/;
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback('内容不能为空');
      } else {
        callback();
      }
    };
    const cost = /^[1-9]\d*|0\,\d*|[1-9]\d*|0$/;
    const validateCost = (rule, value, callback) => {
      if (value === '') {
        callback('内容不能为空');
      } else if (cost.test(value)) {
        callback();
      } else {
        callback('您输入的格式有误');
      }
    };
    const validateMINCost = (rule, value, callback) => {
      if (value === '') {
        callback('内容不能为空');
      } else if (cost.test(value)) {
        if (value > 0 && value < 1) {
          callback();
        } else {
          callback('请输入小数');
        }
      } else {
        callback('您输入的格式有误');
      }
    };
    // const name_code = /^[A-Z]+$/;
    // // eslint-disable-next-line no-unused-vars
    // const validateCode = (rule, value, callback) => {
    //   if (value === '') {
    //     callback('请输入名称缩写');
    //   } else if (name_code.test(value)) {
    //     callback();
    //   } else {
    //     callback('请输入正确格式的名称缩写');
    //   }
    // };
    return {
      筛选表单: {
        档口状态: '1',
      },
      档口状态列表: [{ id: '0', label: '禁用' },
        { id: '1', label: '启用' }],
      dkTypes: [],
      formalSupplierListData: [],
      addFormVisible: false,
      editFormVisible: false,
      pageSize: 10,
      currentPage: 1,
      totalNum: 6,
      // 新增form表单
      addForm: {
        // code: '',
        name: '',
        max_purchase: '',
        leader: '',
        phone: '',
        min_cost: '',
        max_cost: '',
      },
      users: [{
        NAME: '',
        ID: '',
      }],
      editForm: {
        DK_ID: '',
        NAME: '',
        // CODE: '',
        MAX_PURCHASE: '',
        DK_MIN_COST: '',
        DK_MAX_COST: '',
        LEADER_NAME: '',
      },
      rules: {
        name: [
          { required: true, validator: validateName, trigger: 'blur' },
        ],
        max_purchase: [
          { required: true, validator: validateCost, trigger: 'blur' },
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' },
        ],
        leader: [
          { required: true, message: '请选择档口负责人', trigger: 'blur' },
        ],
        NAME: [
          { required: true, validator: validateName, trigger: 'blur' },
        ],
        MAX_PURCHASE: [
          { required: true, validator: validateCost, trigger: 'blur' },
        ],
        DK_MIN_COST: [
          { required: true, validator: validateMINCost, trigger: 'blur' },
        ],
        DK_MAX_COST: [
          { required: true, validator: validateMINCost, trigger: 'blur' },
        ],
        min_cost: [
          { required: true, validator: validateMINCost, trigger: 'blur' },
        ],
        max_cost: [
          { required: true, validator: validateMINCost, trigger: 'blur' },
        ],
      },
      formLabelWidth: '120px',
      statusList: ['大餐', '考核', '外包'],
      importDkDialog: false,
      importDkForm: {
        excel: 'tmp',
      },
      fileList: [],
      loading12: false,
      errorDialog: false,
      errorForm: [],
    };
  },
  methods: {
    // ----档口分类
    queryDKTypes() {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 5,
        TC_ID: parseInt(sessionStorage.getItem('companyId')),
      };
      http.post(params).then((result) => {
        console.log(result);
        this.dkTypes = result[1].list;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    setStatus(row) {
      return this.statusList[row.DK_TYPE - 1];
    },
    // getDK (e) {
    //   this.editForm.DK_TYPE = e
    //   console.log(e)
    // },
    // 获取档口列表
    queryFormalSupplierListData() {
      const data = {
        PROJECT_ID: this.$route.params.siteId,
        STATUS: Number(this.筛选表单.档口状态),
      };
      archivesMouthList(data).then((res) => {
        this.formalSupplierListData = res.length > 0 ? res : [];
        this.totalNum = res.length > 0 ? res.TOTAL_COUNT : 0;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    getPhone(vId) {
      let obj = {};
      obj = this.users.find((item) => /* 这里的userList就是上面遍历的数据源 */ item.ID === vId); // 筛选出匹配数据
      this.addForm.phone = obj.CELLPHONE;
      this.editForm.CELLPHONE = obj.CELLPHONE;
      this.editForm.LEADER_ID = vId;
      console.log(this.editForm.LEADER_ID);
    },
    // 新增档口
    submitAdd(formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const data = {
                PROJECT_ID: this.$route.params.siteId,
                // CODE: this.addForm.code,
                NAME: this.addForm.name,
                CELLPHONE: this.addForm.phone,
                MAX_PURCHASE: this.addForm.max_purchase,
                DK_MIN_COST: this.addForm.min_cost,
                DK_MAX_COST: this.addForm.max_cost,
                LEADER_ID: this.addForm.leader,
              };
              if (this.addForm.INCOME_ADD_POINT) {
                const point = /^[1-9]\d*|0\,\d*|[1-9]\d*|0$/;
                if (!point.test(this.addForm.INCOME_ADD_POINT)) {
                  this.$message.show({ text: '请输入数值类型', type: 'warning' });
                  document.body.style.cursor = 'default';
                  return false;
                }
                data.INCOME_ADD_POINT = this.addForm.INCOME_ADD_POINT;
              }
              // if (this.addForm.code) {
              //   const reg = /[\u4E00-\u9FA5]/g;
              //   if (reg.test(this.addForm.code)) {
              //     this.$message.show({ text: '请不要输入汉字', type: 'warning' });
              //     document.body.style.cursor = 'default';
              //     return false;
              //   }
              // }
              // const flag = this.formalSupplierListData.find((item) => item.DK_CODE == this.addForm.code);
              // console.log(flag);
              // if (flag) {
              //   this.$message.show({ text: '已存在相同的档口缩写，请修改', type: 'warning' });
              //   document.body.style.cursor = 'default';
              //   return false;
              // }
              if (this.addForm.DK_RATE) {
                const point = /^[1-9]\d*|0\,\d*|[1-9]\d*|0$/;
                if (!point.test(this.addForm.DK_RATE)) {
                  this.$message.show({ text: '请输入数值类型', type: 'warning' });
                  document.body.style.cursor = 'default';
                  return false;
                }
                data.DK_RATE = this.addForm.DK_RATE;
              }
              addArchivesMouth(data).then((res) => {
                this.$message.show({
                  text: '新增档口成功',
                  type: 'success',
                });
                this.queryFormalSupplierListData();
                this.addFormVisible = false;
                this.$refs[formName].resetFields();
                document.body.style.cursor = 'default';
              }).catch((error) => {
                // this.$message.show({ text: error, type: 'error' });
                this.$message.show({
                  text: error,
                  type: 'error',
                });
                document.body.style.cursor = 'default';
              });
            } else {
              document.body.style.cursor = 'default';
            }
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    // 新增弹窗
    addUser() {
      this.addFormVisible = true;
      this.queryUser();
    },
    // 修改弹窗
    edit(row) {
      this.editFormVisible = true;
      this.editForm = { ...row, INCOME_FEE_APPORTION_TYPE: Boolean(row.INCOME_FEE_APPORTION_TYPE) };
      // this.editForm=util.deepCopy(row)
      this.queryUser();
      this.emp = JSON.parse(row.MAX_PURCHASE);
    },
    // 关闭弹窗
    closeEditForm() {
      this.editFormVisible.MAX_PURCHASE = this.emp;
      this.editFormVisible = false;
    },
    clearVal() {
      this.editForm.LEADER_ID = 0;
      console.log(this.editForm.LEADER_ID, '改变');
    },
    // 修改档口信息
    submitEdit(formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const data = { // http请求的参数
                DK_ID: this.editForm.ID,
                NAME: this.editForm.NAME,
                // CODE: this.editForm.DK_CODE,
                MAX_PURCHASE: Number(this.editForm.MAX_PURCHASE),
                DK_MIN_COST: Number(this.editForm.DK_MIN_COST),
                DK_MAX_COST: Number(this.editForm.DK_MAX_COST),
                // LEADER_ID: Number(this.editForm.LEADER_ID),
                DK_TYPE: Number(this.editForm.DK_TYPE_ID),
                INCOME_FEE_APPORTION_TYPE: this.editForm.INCOME_FEE_APPORTION_TYPE ? 1 : 0,
              };
              if (this.editForm.INCOME_ADD_POINT) {
                const point = /^[1-9]\d*|0\,\d*|[1-9]\d*|0$/;
                if (!point.test(this.editForm.INCOME_ADD_POINT)) {
                  this.$message.show({ text: '请输入数值类型', type: 'warning' });
                  document.body.style.cursor = 'default';
                  return false;
                }
                data.INCOME_ADD_POINT = this.editForm.INCOME_ADD_POINT;
              }
              if (this.editForm.LEADER_ID) {
                console.log(this.editForm.LEADER_ID, '负责人');
                data.LEADER_ID = Number(this.editForm.LEADER_ID);
              } else {
                data.LEADER_ID = 0;
              }
              // if (this.editForm.DK_CODE) {
              //   const reg = /[\u4E00-\u9FA5]/g;
              //   if (reg.test(this.editForm.DK_CODE)) {
              //     this.$message.show({ text: '请不要输入汉字', type: 'warning' });
              //     document.body.style.cursor = 'default';
              //     return false;
              //   }
              // }
              if (this.editForm.DK_RATE) {
                const point = /^[1-9]\d*|0\,\d*|[1-9]\d*|0$/;
                if (!point.test(this.editForm.DK_RATE)) {
                  this.$message.show({ text: '请输入数值类型', type: 'warning' });
                  document.body.style.cursor = 'default';
                  return false;
                }
                data.DK_RATE = this.editForm.DK_RATE;
              }
              editArchivesMouth(data).then((res) => {
                this.$message.show({ text: '修改档口信息成功', type: 'success' });
                this.queryFormalSupplierListData();
                this.editFormVisible = false;
                this.$refs[formName].resetFields();
                document.body.style.cursor = 'default';
              }).catch((error) => {
                this.$message.show({
                  text: error,
                  type: 'error',
                });
                document.body.style.cursor = 'default';
              });
            } else {
              document.body.style.cursor = 'default';
            }
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    // 禁用档口
    stopUser(row) {
      this.$confirm('您确定禁用该档口吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = { // http请求的参数
          DK_ID: row.ID,
        };
        stopArchivesMouth(data).then((res) => {
          this.$message.show({
            text: '禁用成功',
            type: 'success',
          });
          this.queryFormalSupplierListData();
        }).catch((error) => {
          this.$message.show({
            text: error,
            type: 'error',
          });
        });
      }).catch(() => {
        this.$message.show({
          type: 'info',
          text: '取消操作',
        });
      });
    },
    启用(row) {
      this.$confirm('您确定启用该档口吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = { // http请求的参数
          DK_ID: row.ID,
        };
        enableArchivesMouth(data).then((res) => {
          this.$message.show({
            text: '启用成功',
            type: 'success',
          });
          this.queryFormalSupplierListData();
        }).catch((error) => {
          this.$message.show({
            text: error,
            type: 'error',
          });
        });
      }).catch(() => {
        this.$message.show({
          type: 'info',
          text: '取消操作',
        });
      });
    },
    // 关闭弹窗
    close(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this.editForm.MAX_PURCHASE = this.emp;
      this[`${modalName}`] = false;
    },
    // 获取人员
    queryUser() {
      const data = {
        PAGEINDEX: 0,
        PAGESIZE: 10000,
      };
      getUser(data).then((res) => {
        this.users = res.length > 0 ? res[0].list : [];
        // this.pageSize = res.length > 0 ? res[0].TOTAL_COUNT : 0
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    submitExportDk() {
      console.log(this.file_name);
      console.log(this.$route.params.siteId);
      this.loading12 = true;
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 2,
        FILE_NAME: this.file_name,
        PROJECT_ID: this.$route.params.siteId,
      };
      http.post(params).then((result) => {
        this.loading12 = false;
        if (result.length === 0) {
          this.$message.show({ text: '档口导入完成', type: 'success' });
          this.importDkDialog = false;
          this.queryFormalSupplierListData();
        } else {
          this.$message.show({ text: result[0], type: 'warning' });
          this.errorForm = result;
          this.errorForm.splice(0, 1);
          this.importDkDialog = false;
          this.queryFormalSupplierListData();
          this.errorDialog = true;
        }
      }).catch((error) => {
        this.loading12 = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
  },
  mounted() {
    this.queryFormalSupplierListData();
    this.queryDKTypes();
  },

};
</script>
<style>
.block {
  float: right;
}
</style>




// WEBPACK FOOTER //
// src/components/archivesMouthsManage.vue